const styles = {
  footerSegment: {
    width: '100%',
    background: '#333333',
    margin: '0px',
    padding: '20px',
  },

  footerLeftLabel: {
    height: '25px',
    border: '0px',
    margin: '15px 0px 20px 0px',
    paddingLeft: '0px',
    position: 'relative',
  },

  footerLeftLabelText: {
    marginLeft: '0px',
    fontFamily: 'FuturaTodayBold',
    fontSize: '21px',
    color: '#ffffff',
    textTransform: 'uppercase',
  },

  linkGrid: {
    marginLeft: '0px',
  },

  footerLinkText: {
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    fontSize: '14px',
    marginBottom: '10px',
    lineHeight: '1.43',
    letterSpacing: '0.4px',
    textAlign: 'left',
    color: '#cccccc',
  },

  footerBlurbText: {
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    fontSize: '12px',
    marginBottom: '10px',
    lineHeight: '1.43',
    letterSpacing: '0.4px',
    textAlign: 'left',
    color: '#cccccc',
  },

  footerBlurbLink: {
    color: '#cccccc',
    textDecoration: 'underline',
  },

  footerLinksColumn: {
    padding: '0 20px 0 0px',
    marginLeft: '0px',
  },

  enterEmailInput: {
    width: '100%',
    height: '36px',
    borderRadius: '4px',
    backgroundColor: 'tranparent',
    border: 'solid 1px #999999',
    fontFamily:
      "'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
    fontSize: '12px',
    lineHeight: '1.43',
    letterSpacing: '0.4px',
    color: '#cccccc',
    margin: '0 auto',
    marginBottom: '10px',
    verticalAlign: 'center',
  },

  signUpButton: {
    width: '100%',
    height: '36px',
    borderRadius: '4px',
    backgroundColor: '#dd9933',
    boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.08)',
    fontFamily: 'FuturaTodayBold',
    fontSize: '14px',
    letterSpacing: '0.4px',
    textAlign: 'center',
    color: '#ffffff',
    marginBottom: '14px',
  },

  icon: {
    color: '#dd9933',
    lineHeight: '.66',
    marginLeft: '18px',
    marginRight: '0px',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/app/components/Footer/DesktopFooter/DesktopFooter.styles.js